/*
 * Created by Tigran Yengibaryan
 * Created on 11/06/2021 11:50
 *
 * Copyright (c) 2021 PicsArt.Inc
 */

import styled from 'styled-components';

import { PicsArtIcon } from '../assets/PicsArtIcon';

const Content = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  background: #fff;
`;

const Icon = styled.div<{ left: string }>`
  position: relative;
  left: ${({ left }) => left};
  transform: translateX(-50%);
  cursor: pointer;
`;

export const Header = () => {
  return (
    <Content>
      <Icon left={'50%'}>
        <PicsArtIcon />
      </Icon>
    </Content>
  );
};
